import { withBemMod } from '@bem-react/core';
import { cnButton } from '../Button';
/**
 * @param {IButtonTypeSubmitProps} props
 */
export var withTypeSubmit = withBemMod(cnButton(), { type: 'submit' });
